"use client"

import { createContext, useContext, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import api from "../services/api"
import { postAPI } from "../utils/api-function"
import { userId } from "../utils/constants"

const AuthContext = createContext()

export const useAuth = () => {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem("token")
        const mobile = localStorage.getItem(userId)
        if (token && mobile) {
          const { data } = await postAPI({ url: 'api/app/customer/get_user_profile', payload: { phone: mobile } });
          if (data?.status && data?.data) {
            setCurrentUser(data.data);
          } else {
            // Fallback: restore from localStorage backup
            const saved = localStorage.getItem('customerData');
            if (saved) { try { setCurrentUser(JSON.parse(saved)); } catch (_) {} }
          }
        }
      } catch (error) {
        console.error("Auth check error:", error)
        const saved = localStorage.getItem('customerData');
        if (saved) { try { setCurrentUser(JSON.parse(saved)); } catch (_) {} }
      } finally {
        setLoading(false)
      }
    }

    checkAuth()
  }, [])

  const login = async (email, password) => {
    try {
      const response = await api.post("/auth/login", { email, password })
      const { token, user } = response.data
      localStorage.setItem("token", token)
      localStorage.setItem('userId', user._id)
      setCurrentUser(user)
      return user
    } catch (error) {
      console.error("Login error:", error)
      throw error
    }
  }

  const register = async (userData) => {
    try {
      const response = await api.post("/auth/register", userData)
      const { token, user } = response.data
      localStorage.setItem("token", token)
      setCurrentUser(user)
      return user
    } catch (error) {
      console.error("Registration error:", error)
      throw error
    }
  }

  const logout = async () => {
    try {
      localStorage.removeItem("token")
      localStorage.removeItem("userId")
      setCurrentUser(null)
      navigate("/login")
    } catch (error) {
      console.error("Logout error:", error)
      throw error
    }
  }

  const adminLogin = async (email, password) => {
    try {
      const response = await api.post("/auth/login", { email, password })
      const { token, user } = response.data
      localStorage.setItem("token", token)
      setCurrentUser(user)
      return user
    } catch (error) {
      console.error("Admin login error:", error)
      throw error
    }
  }

  const value = {
    currentUser,
    setCurrentUser,
    loading,
    login,
    register,
    logout,
    adminLogin,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
